import api from "./gciTrackerApi";
import {
  gciTrackerSettingsLoading,
  gciTrackerSettingsLoadingError,
  gciTrackerSettingsLoaded,
  gciTrackerSettingsUpdating,
  gciTrackerSettingsUpdatingError,
  gciTrackerSettingsUpdated,
} from "./gciTrackerStateActions";
import { IGciTrackerSettings } from "../../../types/types";
import {
  GciTrackerSettingsResponse,
  UpdateGciTrackerSettingsRequest,
} from "../../repsaApi";

export function fetchGciTrackerSettings() {
  return function (dispatch: any) {
    dispatch(gciTrackerSettingsLoading());
    api.getSettings().then(
      (data: GciTrackerSettingsResponse) =>
        dispatch(gciTrackerSettingsLoaded(data)),
      (error: Error) => dispatch(gciTrackerSettingsLoadingError(error.message)),
    );
  };
}

export function updateGciTrackerSettings(
  settings: Partial<IGciTrackerSettings>,
) {
  return function (dispatch: any) {
    dispatch(gciTrackerSettingsUpdating());
    api.updateSettings(settings as UpdateGciTrackerSettingsRequest).then(
      (data: IGciTrackerSettings) => dispatch(gciTrackerSettingsUpdated(data)),
      (error: any) =>
        dispatch(
          gciTrackerSettingsUpdatingError(
            error.response?.data?.message ??
              error.message ??
              "Failed to update GCI Tracker settings",
          ),
        ),
    );
  };
}
